<div class="pt-2 pl-2">
    <button mat-button mat-raised-button color="primary" routerLink='/users'>
        <span class="material-icons">
            arrow_back
        </span>
        Back
    </button>
</div>

<mat-toolbar>User Form</mat-toolbar>

<app-dynamic-form-molecule *ngIf="formData" [showDeleteButton]="true" [formData]='formData' [addFlag]='addFlag' (submitForm)="submitForm($event)" (deleteForm)="deleteForm($event)"></app-dynamic-form-molecule>
